<div class="container-fluid page-container">
    <div class="row">
        <div class="col">
            <form *ngIf="formGroup" [formGroup]="formGroup" (ngSubmit)="handleSubmit($event)">
                <div class="row" *ngFor="let column of config">
                    <div class="col-7" *ngIf="column.type.indexOf('boolean') === -1; else isRadio">
                        <lsq-input
                            *ngIf="column.type === 'string' && !column.textarea"
                            [name]="column.name"
                            [label]="column.name"
                            [formControlName]="column.name"
                            [group]="formGroup"
                            [readOnly]="column.readOnly"
                        >
                        </lsq-input>

                        <lsq-input
                            *ngIf="column.type === 'Guid'"
                            [name]="column.name"
                            [label]="column.name"
                            [formControlName]="column.name"
                            [group]="formGroup"
                            [readOnly]="column.readOnly"
                        >
                        </lsq-input>

                        <lsq-input
                            *ngIf="column.type === 'DateTime'"
                            [name]="column.name"
                            [label]="column.name"
                            [formControlName]="column.name"
                            [group]="formGroup"
                            [readOnly]="column.readOnly"
                        >
                        </lsq-input>

                        <!-- If data needs a number input -->
                        <lsq-input
                            *ngIf="column.type === 'number'"
                            type="number"
                            [name]="column.name"
                            [label]="column.name"
                            [formControlName]="column.name"
                            [group]="formGroup"
                            [readOnly]="column.readOnly"
                        >
                        </lsq-input>

                        <!-- If data needs a textarea -->
                        <lsq-textarea
                            *ngIf="column.type === 'string' && column.textarea"
                            [name]="column.name"
                            [label]="column.name"
                            [formControlName]="column.name"
                            [group]="formGroup"
                            [readOnly]="column.readOnly"
                        >
                        </lsq-textarea>

                        <!-- If data is enum -->
                        <lsq-select
                            *ngIf="column.type === 'select'"
                            [label]="column.name"
                            [name]="column.name"
                            [formControlName]="column.name"
                            [innerLabel]="true"
                            [isNullable]="column.nullable"
                            [options]="column.options | iterable"
                        >
                        </lsq-select>
                    </div>

                    <ng-template #isRadio>
                        <div class="col-5">
                            <!-- If data is boolean, non-nullable -->
                            <fieldset
                                [id]="column.name"
                                *ngIf="
                                    column.type === 'boolean' &&
                                    (column.defaultValue === true || column.defaultValue === false)
                                "
                            >
                                <label for="r2-true">True</label>
                                <input
                                    type="radio"
                                    id="r2-true"
                                    [formControlName]="column.name"
                                    [value]="true"
                                />
                                <label for="r2-false">False</label>
                                <input
                                    type="radio"
                                    id="r2-false"
                                    [formControlName]="column.name"
                                    [value]="false"
                                />
                            </fieldset>

                            <!-- If data is boolean, nullable -->
                            <fieldset
                                [id]="column.name"
                                *ngIf="
                                    column.type === 'boolean' &&
                                    column.defaultValue !== true &&
                                    column.defaultValue !== false
                                "
                            >
                                <label for="r3-true">true</label>
                                <input
                                    type="radio"
                                    id="r3-true"
                                    [formControlName]="column.name"
                                    [value]="true"
                                />
                                <label for="r3-false">false</label>
                                <input
                                    type="radio"
                                    id="r3-false"
                                    [formControlName]="column.name"
                                    [value]="false"
                                />
                                <label for="r3-null">null</label>
                                <input
                                    type="radio"
                                    id="r3-null"
                                    [formControlName]="column.name"
                                    [value]="null"
                                />
                            </fieldset>
                        </div>
                    </ng-template>

                    <div class="col-5">
                        Errors: {{ formGroup.controls[column.name].errors | json }}
                    </div>
                </div>
                <div>
                    <button class="btn-success">Execute</button>
                    <button
                        *ngIf="formCancel.observers.length > 0"
                        type="button"
                        class="btn btn-success"
                        (click)="handleCancel()"
                    >
                        Cancel
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
